function setCarouselSpeed(carousel, parentCarousel = null) {
    if (!carousel) return;

    const groups = carousel.querySelectorAll(".flindersonline-carousel__group");
    
    const isHidden = groups[0] && groups[0].offsetWidth === 0;
    
    if (isHidden) {
        carousel.setAttribute('data-needs-init', 'true');
        return;
    }
    
    carousel.removeAttribute('data-needs-init');

    const sourceCarousel = parentCarousel || carousel;
    const rotationSpeed = sourceCarousel.getAttribute("data-rotation-speed");
    const direction = sourceCarousel.getAttribute("data-direction");

    let pixelsPerSecond;
    switch (rotationSpeed) {
        case "slow":
            pixelsPerSecond = 100;
            break;
        case "medium":
            pixelsPerSecond = 200;
            break;
        case "fast":
            pixelsPerSecond = 300;
            break;
        default:
            pixelsPerSecond = rotationSpeed && !isNaN(rotationSpeed) ? parseInt(rotationSpeed) : 100;
    }

    groups.forEach((group) => {
        const contentWidth = group.scrollWidth;
        const duration = contentWidth / pixelsPerSecond;
        
        group.style.animationDuration = `${duration}s`;
        
        if (direction === "rightToLeft") {
            group.classList.remove("flindersonline-carousel__group--reverse");
            group.classList.add("flindersonline-carousel__group--normal");
        } else {
            group.classList.remove("flindersonline-carousel__group--normal");
            group.classList.add("flindersonline-carousel__group--reverse");
        }
    });
}

function handleAuthoringMode(carousel) {
    if (!carousel) return;

    const isAuthoring = carousel.getAttribute("data-authoring") === "true";
    const groups = carousel.querySelectorAll(".flindersonline-carousel__group");

    groups.forEach((group) => {
        if (isAuthoring) {
            group.style.animationPlayState = "paused";
        } else {
            group.style.animationPlayState = "running";
        }
    });
}

function handleMobileCarousels(carousel) {
    if (!carousel) return;

    const isMobile = window.innerWidth < 768;
    const mobileWrapper = carousel.querySelector(".mobile-carousel-wrapper");
    
    if (!isMobile || !mobileWrapper) return;

    const firstCarousel = mobileWrapper.querySelector(".mobile-carousel-first");
    const secondCarousel = mobileWrapper.querySelector(".mobile-carousel-second");
    
    if (!firstCarousel || !secondCarousel) return;

    const desktopCarousel = carousel.querySelector(".flindersonline-carousel.desktop-carousel");
    
    if (!desktopCarousel) {
        return;
    }
    
    const desktopFirstGroup = desktopCarousel.querySelector(".flindersonline-carousel__group");
    
    if (!desktopFirstGroup) {
        return;
    }

    const logoCount = desktopFirstGroup.querySelectorAll(".flindersonline-carousel__item").length;
    
    if (!carousel.dataset.originalMobileItemsStored) {
        const firstGroups = firstCarousel.querySelectorAll(".flindersonline-carousel__group");
        const secondGroups = secondCarousel.querySelectorAll(".flindersonline-carousel__group");
        
        carousel.dataset.firstCarouselOriginal = JSON.stringify(
            Array.from(firstGroups).map(group => group.innerHTML)
        );
        carousel.dataset.secondCarouselOriginal = JSON.stringify(
            Array.from(secondGroups).map(group => group.innerHTML)
        );
        carousel.dataset.originalMobileItemsStored = 'true';
    }
    
    if (carousel.dataset.firstCarouselOriginal && carousel.dataset.secondCarouselOriginal) {
        const firstOriginal = JSON.parse(carousel.dataset.firstCarouselOriginal);
        const secondOriginal = JSON.parse(carousel.dataset.secondCarouselOriginal);
        
        const firstGroups = firstCarousel.querySelectorAll(".flindersonline-carousel__group");
        const secondGroups = secondCarousel.querySelectorAll(".flindersonline-carousel__group");
        
        firstGroups.forEach((group, index) => {
            if (firstOriginal[index]) {
                group.innerHTML = firstOriginal[index];
            }
        });
        
        secondGroups.forEach((group, index) => {
            if (secondOriginal[index]) {
                group.innerHTML = secondOriginal[index];
            }
        });
    }
    
    if (logoCount > 5) {
        const midPoint = Math.ceil(logoCount / 2);
        
        const firstGroups = firstCarousel.querySelectorAll(".flindersonline-carousel__group");
        firstGroups.forEach(group => {
            const items = Array.from(group.querySelectorAll(".flindersonline-carousel__item"));
            items.slice(midPoint).forEach(item => item.remove());
        });
        
        const secondGroups = secondCarousel.querySelectorAll(".flindersonline-carousel__group");
        secondGroups.forEach(group => {
            const items = Array.from(group.querySelectorAll(".flindersonline-carousel__item"));
            items.slice(0, midPoint).forEach(item => item.remove());
        });

        if (secondCarousel) {
            secondCarousel.style.display = "flex";
        }
        
        setCarouselSpeed(firstCarousel, carousel);
        setCarouselSpeed(secondCarousel, carousel);
        
    } else {
        if (secondCarousel) {
            secondCarousel.style.display = "none";
        }
        
        setCarouselSpeed(firstCarousel, carousel);
    }
}

function initializeCarousel(carousel) {
    if (!carousel) return;
    
    handleAuthoringMode(carousel);
    handleMobileCarousels(carousel);
    setCarouselSpeed(carousel);
}

function reinitializeCarousel(carousel) {
    if (!carousel) return;
    
    carousel.classList.remove("mobile-processed");
    
    handleAuthoringMode(carousel);
    handleMobileCarousels(carousel);

    const desktopCarousel = carousel.querySelector('.desktop-carousel');
    if (desktopCarousel) {
        setCarouselSpeed(desktopCarousel, carousel);
    }
}

function reinitializeAllCarousels() {
    const carousels = document.querySelectorAll(".cmp-flindersonline-moving-carousel");
    carousels.forEach(carousel => {
        reinitializeCarousel(carousel);
    });
}

function initializeDeferredCarousels() {
    const deferredCarousels = document.querySelectorAll(".cmp-flindersonline-moving-carousel[data-needs-init='true']");
    
    deferredCarousels.forEach(carousel => {
        const groups = carousel.querySelectorAll(".flindersonline-carousel__group");
        const isVisible = groups[0] && groups[0].offsetWidth > 0;
        
        if (isVisible) {
            reinitializeCarousel(carousel);
        }
    });
}

function setupCarouselObserver() {
    const carousels = document.querySelectorAll(".cmp-flindersonline-moving-carousel");
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const needsInit = entry.target.getAttribute('data-needs-init') === 'true';
                
                if (needsInit) {
                    setTimeout(() => {
                        reinitializeCarousel(entry.target);
                    }, 100);
                } else {
                    setTimeout(() => {
                        reinitializeCarousel(entry.target);
                    }, 100);
                }
            }
        });
    }, {
        threshold: 0.1
    });
    
    carousels.forEach(carousel => {
        observer.observe(carousel);
    });
}

function initializeAllCarousels() {
    const carousels = document.querySelectorAll(".cmp-flindersonline-moving-carousel");
    
    carousels.forEach(carousel => {
        initializeCarousel(carousel);
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
        initializeAllCarousels();
        setupCarouselObserver();
    });
} else {
    initializeAllCarousels();
    setupCarouselObserver();
}

window.addEventListener("load", function () {
    setTimeout(() => {
        initializeAllCarousels();
        setupCarouselObserver();
    }, 100);
});